import React from "react";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useApproverDeleteMutation } from "../../../../../services/ticketEasyService/ticketEasy-api";
import { useDispatch } from "react-redux";
import { removeApprover } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketTypeConfig/TicketTypeConfigSlice";

interface ApproverDeleteButtonProps {
    approverId: string;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

export const ApproverDeleteButton: React.FC<ApproverDeleteButtonProps> = ({
    approverId,
    onSuccess,
    onError,
}) => {
    const dispatch = useDispatch();
    const [deleteApprover, { isLoading }] = useApproverDeleteMutation();

    const handleClick = async () => {
        try {
            await deleteApprover(approverId).unwrap();
            dispatch(removeApprover(approverId));
            if (onSuccess) onSuccess();
            alert("Approver removed successfully!");
        } catch (error: any) {
            if (onError) onError(error.message);
            alert("Failed to remove approver: " + error.message);
        }
    };

    return (
        <IconButton
            onClick={handleClick}
            color="error"
            disabled={isLoading}
            aria-label="delete approver"
        >
            <DeleteIcon />
        </IconButton>
    );
};
